import "./style.less";
import repeatableBookings from "./directive";
import repeatableBookingFactory from "./factory";
import repeatableBookingService from "./service";
import repeatableResults from "./repeatable-results";
import repeatableResultsFactory from "./repeatable-results/factory";

const modul = angular
    .module("repeatableBookingDirectives", [])

    .directive("repeatableBookings", repeatableBookings)

    .factory("repeatableBookingFactory", repeatableBookingFactory)

    .service("repeatableBookingService", repeatableBookingService)

    .directive("repeatableResults", repeatableResults)

    .factory("repeatableResultsFactory", repeatableResultsFactory);

export default modul.name;
